export { type VideoCaptureProps } from './VideoCapture';
export { VideoCaptureHOC as VideoCapture } from './VideoCaptureHOC';
